export const api = {
  user: {
    LOGIN: () => '/user/user/login/',
    MYSELF: () => '/user/user/self/',
    REGISTER: () => '/user/user/register/create/',
    PASSWORD_FORGET: () => '/user/user/password-forget/',
    GET_SMS_CAPTCHA: () => '/user/captcha/phone/sms/',
    CHECK_SMS_CAPTCHA: () => '/user/captcha/phone/sms/',
    CAPTCHA_TENCENT: () => '/user/captcha/tencent/',
    WX_USER_LIST: () => '/user/wechat/user/self/',
    BIND_WECHAT: () => '/user/wechat/user/bind-qr-code/',
    UNBIND_WECHAT: (uuid) => `/user/wechat/user/${uuid}/unbind/`,
    EMAIL_CHANGE: () => '/user/user/self/email-change/',
    PHONE_CHANGE: () => '/user/user/self/phone-change/',
    PASSWORD_CHANGE: () => '/user/user/self/password-change/',
    LOGOUT: () => '/user/user/logout/',
    GETUSERLOG: () => '/user/login-history/self/',
    GETPHONEALLEVENTLIST: () => '/user/black-phone-operation/self/events/',
    PHONEUPLOADPARM: () => '/user/black-phone-operation/self/event-upload-parm/',
    GETPHONEFEEDBACKDETAIL: (eventId) => `/user/black-phone-operation/self/events/${eventId}/`,
    GET_PHONE_CHART_DATA_HOURLY: () => '/user/self/usage-statistic/phone/online/hourly/',
    GET_PHONE_CHART_DATA_DAILY: () => '/user/self/usage-statistic/phone/online/daily/',
    GET_IP_CHART_DATA_HOURLY: () => '/user/self/usage-statistic/ip/online/hourly/',
    GET_IP_CHART_DATA_DAILY: () => '/user/self/usage-statistic/ip/online/daily/',
    GET_PHONE_OFFLINE_UPDATE_PACKAGE: () => '/user/self/usage-statistic/phone/offline/',
    GET_IP_OFFLINE_UPDATE_PACKAGE: () => '/user/self/usage-statistic/ip/offline/',
    GET_IP_LIST: () => '/user/self/white-ip/',
    DEL_IP: () => '/user/self/white-ip/'
  },
  yongan: {
    PHONE_USAGE: () => '/yongan/phone/usage-count/',
    PRODUCT_LIST: () => '/yongan/busi/getall',
    GET_KEY: () => '/yongan/user/getsnkey'
  },
  fingerprint: {
    FINERPRINT_AGGREGATE: () => '/fingerprint/device/device-check-record/aggregate/',
    FINERPRINT_List: () => '/fingerprint/device/device-check-record/',
    FINERPRINT_TAG: () => '/fingerprint/device/tag/'
  },
  official: {
    PDF_READ: () => '/api/official-website/pdf/read?start=0&limit=3'
  },
  public: {
    GET_EMAIL_TYPE: () => '/public/email-type/',
    USER_FEEDBACK: () => '/public/feedback/email/'
  }
}
